module.exports = __webpack_public_path__ + "static/img/pipline2.bf302f15.jpeg";